exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-backdrop {\n  /* bug fix - no overlay */\n  display: none;\n}\n.modal {\n  /* bug fix - custom overlay */\n  background-color: #2625258f;\n}\n.multiselect__option--highlight .syncced {\n  color: black;\n}\n.checkboxcolumns {\n  -moz-column-count: 2;\n       column-count: 2;\n  -moz-column-gap: 2rem;\n       column-gap: 2rem;\n  list-style: none;\n  padding: 0;\n}\n", ""]);

// exports
